import { Button } from '@cian/ui-kit/button';
import { IconSearch16, IconClose12 } from '@cian/ui-kit/icons';
import { Input } from '@cian/ui-kit/input';
import { ModalWindow } from '@cian/ui-kit/modal';
import * as React from 'react';

import * as styles from './SearchBlockModal.css';

const TAGS: string[] = [
  'Снять квартиру рядом с метро',
  'Купить 2 комнатную квартиру',
  'Купить дом недорого',
  'Снять квартиру без посредников',
  'Снять дом',
];

interface ISearchBlockModalProps {
  open: boolean;
  inputValue: string;
  withTags?: boolean;
  onClose(): void;
  onSearch(query: string): void;
  setInputValue(query: string): void;
}

export const SearchBlockModal: React.FC<ISearchBlockModalProps> = ({
  open,
  inputValue,
  onClose,
  onSearch,
  setInputValue,
  withTags,
}) => {
  const [withSearchIcon, setWithSearchIcon] = React.useState(true);
  const [withCloseIcon, setWithCloseIcon] = React.useState(false);
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (open && inputRef.current) {
      inputRef.current.focus();
    }
  }, [open]);

  React.useEffect(() => {
    if (inputValue && !withCloseIcon) {
      setWithCloseIcon(true);
    } else if (!inputValue && withCloseIcon) {
      setWithCloseIcon(false);
    }
  }, [inputValue, withCloseIcon]);

  const handleSearch = React.useCallback(() => {
    onSearch(inputValue);
    onClose();
  }, [inputValue, onClose, onSearch]);

  const handleSubmit: React.FormEventHandler = e => {
    e.preventDefault();
    onSearch(inputValue);
    onClose();
  };

  return (
    <ModalWindow
      title="Вся недвижимость здесь. Просто Зациань!"
      open={open}
      onClose={onClose}
      size="XS"
      fixed
      content={
        <div className={styles['container']}>
          <form className={styles['form']} action="#" onSubmit={handleSubmit}>
            <Input
              inputRef={inputRef}
              leftAdornment={
                withSearchIcon && (
                  <div className={styles['search-icon']}>
                    <IconSearch16 />
                  </div>
                )
              }
              rightAdornment={
                withCloseIcon && (
                  <button
                    type="button"
                    title="Стереть ввод"
                    className={styles['close-button']}
                    onClick={() => {
                      if (inputRef.current) {
                        inputRef.current.focus();
                      }
                      setInputValue('');
                    }}
                  >
                    <IconClose12 />
                  </button>
                )
              }
              value={inputValue}
              onChange={(_, value) => setInputValue(value)}
              onFocus={() => setWithSearchIcon(false)}
              onBlur={() => {
                if (!inputValue) {
                  setWithSearchIcon(true);
                }
              }}
            />
          </form>
          {withTags && (
            <ul className={styles['list']}>
              {TAGS.map((tag, index) => (
                <li key={`tag_${tag}_${index}`}>
                  <button
                    type="button"
                    onClick={() => {
                      setInputValue(tag);
                      setWithSearchIcon(false);
                    }}
                  >
                    {tag}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      }
      footer={
        <Button fullWidth disabled={!inputValue} onClick={handleSearch}>
          Найти
        </Button>
      }
    />
  );
};
